// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"index__UtilityBoxItem___1vE7E","childWrapper":"index__childWrapper___3SASw","image":"index__image___2jm1Q"};